(function () {
  var cachedMin = null;

  function pesos(amount) {
    var value = Math.max(0, Math.round(Number(amount) || 0));
    return '$' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function probeMinimum() {
    var mm = window.minMaxify;
    if (!mm || typeof mm.handleCartUpdate !== 'function' || typeof mm.checkLimits !== 'function') return null;
    var original = JSON.parse(JSON.stringify(mm.cart || { items: [], item_count: 0, total_price: 0, total_weight: 0 }));

    function allowed(amount) {
      mm.handleCartUpdate(
        {
          total_price: amount * 100,
          total_weight: 0,
          item_count: 1,
          items: [{ id: 1, quantity: 1, line_price: amount * 100, grams: 0, price: amount * 100 }],
        },
        'update'
      );
      return mm.checkLimits() !== false;
    }

    var minimum = null;
    if (!allowed(0)) {
      var low = 0;
      var high = 1;
      while (!allowed(high) && high < 100000000) high *= 2;
      while (low + 1 < high) {
        var mid = Math.floor((low + high) / 2);
        if (allowed(mid)) high = mid;
        else low = mid;
      }
      minimum = high;
    }

    mm.handleCartUpdate(original, 'update');
    return minimum;
  }

  function minimumAmount() {
    if (cachedMin !== null) return cachedMin;
    cachedMin = probeMinimum();
    return cachedMin;
  }

  function paint(cart) {
    var minimum = minimumAmount();
    var total = Number(cart.total_price || 0) / 100;
    var below = Boolean(minimum) && cart.item_count > 0 && total < minimum;
    var missingLabel = pesos((minimum || 0) - total);
    var minimumLabel = pesos(minimum || 0);

    document.querySelectorAll('[data-mj-cart-min-cta]').forEach(function (cta) {
      cta.hidden = !below;
      cta.textContent = below ? 'Te faltan ' + missingLabel + ' · mira los más vendidos →' : '';
    });
    document.querySelectorAll('[data-mj-cart-checkout]').forEach(function (button) {
      var payLabel = button.dataset.labelPay || 'Ir a pagar';
      if (below) {
        button.classList.add('is-below-min');
        button.disabled = true;
        button.removeAttribute('name');
        button.textContent = 'Ir a pagar · mínimo ' + minimumLabel;
      } else if (cart.item_count > 0) {
        button.classList.remove('is-below-min');
        button.disabled = false;
        button.setAttribute('name', 'checkout');
        button.textContent = payLabel;
      }
    });
    snapshot = {
      below: below,
      cta: below ? 'Te faltan ' + missingLabel + ' · mira los más vendidos →' : '',
      button: below ? 'Ir a pagar · mínimo ' + minimumLabel : null,
    };
  }

  var snapshot = null;
  var repaintTimers = [];
  var repairs = 0;

  function drifted() {
    if (!snapshot || !snapshot.below || repairs > 8) return false;
    var off = false;
    document.querySelectorAll('[data-mj-cart-min-cta]').forEach(function (cta) {
      if (cta.hidden || cta.textContent !== snapshot.cta) off = true;
    });
    document.querySelectorAll('[data-mj-cart-checkout]').forEach(function (button) {
      if (!button.disabled || button.textContent !== snapshot.button) off = true;
    });
    return off;
  }

  var observer = new MutationObserver(function () {
    if (!drifted()) return;
    repairs += 1;
    window.applyMjCartMinimum();
  });

  function watch() {
    document.querySelectorAll('cart-drawer, #main-cart-footer').forEach(function (root) {
      if (root.dataset.mjMinWatch) return;
      root.dataset.mjMinWatch = '1';
      observer.observe(root, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['hidden', 'disabled', 'class'],
      });
    });
  }

  window.applyMjCartMinimum = function () {
    if (!window.minMaxify) return;
    fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(paint)
      .catch(function () {});
  };

  function scheduleRepaint() {
    repairs = 0;
    repaintTimers.forEach(clearTimeout);
    repaintTimers = [0, 200, 600, 1200].map(function (delay) {
      return setTimeout(function () {
        watch();
        window.applyMjCartMinimum();
      }, delay);
    });
  }

  function boot() {
    scheduleRepaint();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleRepaint);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  var tries = 0;
  var wait = setInterval(function () {
    tries += 1;
    if (window.minMaxify || tries > 20) {
      clearInterval(wait);
      boot();
    }
  }, 300);
})();
